import { Sticker, StickerVariant } from '@bytel/trilogy-react-ts';

export default function SharedSticker({
    children,
    radioFlagColor = 'BYOU',
}: Readonly<{
    children: React.ReactNode;
    radioFlagColor?: StickerVariant | 'BYOU';
}>) {
    return (
        <Sticker
            small
            className={radioFlagColor === 'BYOU' ? 'byou-sticker' : ''}
            variant={radioFlagColor as StickerVariant}
        >
            {children}
        </Sticker>
    );
}
